import React, { useEffect, useState } from 'react';
import { Button } from '../../../components/forms/Buttons/Button';
import { CheckIcon, KeyIcon } from '@heroicons/react/24/outline';
import CustomDialog from '../../../components/modals/CustomDialog/CustomDialog';
import { Controller, useForm } from 'react-hook-form';
import Select from '../../../components/forms/Select/Select';
import useSnackbar from '../../../utils/hooks/useSnackbar';
import { patchSetting } from '../../../services/settings/settingsService';

const SettingEditModal = ({ setting, schools, getData }) => {
  const { addSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);

  const { handleSubmit, control } = useForm();

  const onSubmit = (data) => {
    patchSetting(setting.uuid, data)
      .then(() => {
        addSnackbar('Updated', 'success');
      })
      .catch((error) => {
        addSnackbar(error, 'error');
      })
      ?.finally(() => {
        getData();
      });
  };

  useEffect(() => {}, []);

  return (
    <>
      <div className='flex flex-row items-center gap-4'>
        <span>{setting.allowed_schools.length}</span>
        <Button text={'Доступ'} Icon={KeyIcon} onClick={() => setOpen(true)} />
      </div>
      <CustomDialog
        isOpen={open}
        headerText={setting.name}
        closeModal={() => {
          setOpen(false);
        }}
      >
        <form
          onSubmit={handleSubmit(onSubmit)}
          className='flex min-h-[12rem] flex-col justify-between gap-2'
        >
          <div className='flex flex-col gap-2'>
            <label>
              <span>Школы</span>
              <span className='text-error'>*</span>
            </label>
            <Controller
              control={control}
              name={`allowed_schools`}
              defaultValue={setting.allowed_schools}
              render={({ field }) => (
                <div className='flex flex-col items-end justify-center gap-2'>
                  <Select
                    className='w-full'
                    isMulti
                    isSearchable={false}
                    value={field.value}
                    options={schools.map((school) => ({
                      value: school.uuid,
                      label: school.name,
                    }))}
                    onChange={(e) => {
                      field.onChange(
                        e?.map((p) => {
                          return p?.value;
                        }),
                      );
                    }}
                  />
                  <Button
                    className='w-60'
                    text={'Выбрать всех'}
                    Icon={CheckIcon}
                    type='button'
                    onClick={() => {
                      field.onChange(
                        schools?.map((p) => {
                          return p?.uuid;
                        }),
                      );
                    }}
                  />
                </div>
              )}
            />
          </div>
          <div className='flex flex-row justify-end'>
            <Button text='Изменить' type='submit' color='success' />
          </div>
        </form>
      </CustomDialog>
    </>
  );
};

export default SettingEditModal;
